export const checkIsValidAddress = (order) => {
  let isValid = true;

  if (order.shippingAddress.checked) return true;

  // Google-Adressprüfung (orders.addressValidation, 23.10.2026) — gleiche Logik wie autoFulfillOrders.validateAddress:
  // grün = gültig (auch wenn die Regex unten meckert, z. B. Ortsteil im Adresszusatz), gelb/rot = prüfen (orange Zeile).
  // Ohne Prüfergebnis (ungeprüft, Land nicht unterstützt, API-Fehler) gilt die alte Regex.
  const v = order.addressValidation;
  if (v && v.state === "ok") return true;
  if (v && (v.state === "review" || v.state === "problem")) return false;

  // Check if addressPrimary ends or starts (FR) with a digit or digit followed by one char
  isValid =
    isValid &&
    /^(\d+\s?[A-Za-z]?\s.*|.*\s\d+\s?[A-Za-z]?)\s?$/.test(
      order.shippingAddress.addressPrimary
    );

  // Check if addressSecondary is not defined or empty
  isValid =
    isValid &&
    (!order.shippingAddress.addressSecondary ||
      order.shippingAddress.addressSecondary.trim() === "");

  return isValid;
};
